<script lang="ts" context="module">
  const getAspectRatio = (n: number) => {
    switch (n) {
      case 1:
        return 'aspect-[374/560] lg:aspect-[1376/560]';
      case 2:
        return 'aspect-[374/560] lg:aspect-[680/560]';
      case 3:
        return 'aspect-[354/560] lg:aspect-[448/560]';
      default:
        break;
    }
  };
</script>

<script lang="ts">
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import type { ImageRowStoryblok } from '$types/bloks';
  import ResponsiveImage from './responsive-image.svelte';

  export let row: ImageRowStoryblok;
</script>

<div
  class={cn(
    'flex gap-2 lg:gap-4 flex-col lg:flex-row',
    row.images.length >= 3 && 'flex-row overflow-y-auto -mx-2 px-2 hide-scrollbar lg:mx-0 lg:px-0'
  )}
  use:storyblokEditable={row}
>
  {#each row.images as image}
    <ResponsiveImage
      {image}
      class={cn(row.images.length >= 3 && 'min-w-[90%] lg:min-w-[unset]')}
      imgClass={cn('rounded-md object-cover', getAspectRatio(row.images.length))}
    />
  {/each}
</div>
